export { SenderChipContainer } from '@/features/sender-selection/components/SenderChipContainer';
